export default {
  bind(el,binding) {
    const findInnerInput = () =>{
      return el.querySelector('input.ivu-select-input') || el.querySelector('.ivu-select-selection');
    }
    const handleBlur = (e) => {
      if (binding.value) binding.value(e)
    }

    const addListeners = () => {
      const input = findInnerInput()
      if (input) {
        input.addEventListener('blur',handleBlur)
        /*input.addEventListener('focus',()=>{
          binding.vm.selecting = true
        })*/

        el._blurHandler = handleBlur
        el._inputElement = input
      }
    };
    const observer = new MutationObserver(()=>{
      if (!el._inputElement) {
        addListeners()
      }
    })

    observer.observe(el,{childList:true, subtree: true})
    addListeners()
  },
  unbind(el, binding) {
    if (el._blurHandler && el._inputElement) {
      el._inputElement.removeEventListener('blur',el._blurHandler)
      delete el._inputElement
      delete el._blurHandler
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/module/selectblur.js